import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner,
  ExportToExcel
} from '../../config/react'
import DataTable from 'react-data-table-component'

const Newsletter = () => {
  const [NewsletterList, setNewsletterList] = useState([])
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [SearchTerm, setSearchTerm] = useState('')

  const columns = [
    {
      name: 'Template',
      sortable: true,
      sortField: 'template_id',
      selector: (row) => row.template_id
    },
    {
      name: 'Scheduled On',
      sortable: true,
      sortField: 'schedule_on',
      selector: (row) => <DateFormat value={row.schedule_on}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) =>
        row.is_send === 1 ? 'Sent' : row.is_cancelled === 1 ? 'Cancelled' : 'Pending'
    },
    // {
    //     name: 'Message',
    //     selector: row => row.message,
    // },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          {row.is_send === 1 || row.is_cancelled === 1 ? (
            ''
          ) : (
            <Link
              onClick={(e) => CancelNewsletter(e, row.batchId)}
              to="#"
              className="text-dark"
              title="Cancel Newsletter"
            >
              <i
                className="fa fa-trash-o"
                aria-hidden="true"
              ></i>{' '}
            </Link>
          )}
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  const GetNewsletterList = () => {
    const newsletterData = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    // HttpService.getApi(API.GetNewsletterList).then(response => {
    setLoading(true)
    HttpService.postApi(API.GetNewsletterList, newsletterData).then((response) => {
      setLoading(false)
      // setNewsletterList(response.data.result[0])
      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];
        setNewsletterList(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_newsletters)
      }
    })
  }

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Newsletter
    GetNewsletterList()
  }, [CustomFilters, SearchTerm])

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Template."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })

  const CancelNewsletter = (e, batchId) => {
    const param = {
      batchId
    }
    swal(Messages.Swalcancelnewsletter).then(function (isConfirm) {
      if (isConfirm) {
        setLoading(true)
        HttpService.postApi(API.CancelNewsletter, param).then((response) => {
          setLoading(false)
          if (response.message) {
            toast.warning(response.message)
          } else {
            toast.success(Messages.NewsletterCancelled)
            GetNewsletterList()
            setForceUpdate(!isForceUpdate)
          }
        })
      }
    })
  }
  const handleExportExcel = () => {
    HttpService.getApi(API.GetNewsletterExcel).then((response) => {
      if (response.data.result) {
        ExportToExcel(response.data.result[0], 'Newsletter')
      }
    })
  }
  const handleSort = (e, direction) => {
    // console.log('LN 131 Sort FIeld ' + e.sortField)
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Newsletter} </h3>
        <div className="btn-group">
          <Link
            to="/newsletter/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Newsletter
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <button
                className="btn btn-primary float-right m-1"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
              <div className="table-responsive">
                <DataTable
                  // title="Newsletter List"
                  columns={columns}
                  data={NewsletterList}
                  // progressPending={loading}
                  paginationDefaultPage={currentPage}
                  pagination
                  paginationServer
                  persistTableHead={true}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Newsletter
